var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEconomiaAziendaleDeselected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 193.47 260.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #eb4548;\n      }\n\n      .cls-2 {\n        fill: #8486c0;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raccolta"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "57 259.12 53.76 134.07 29.05 134.07 39.86 259.16 57 259.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "97.32 260.25 95.06 26.62 68.68 22.85 77.73 257.99 97.32 260.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "138.36 258.84 134.59 191.77 114.99 191.77 115.75 256.58 138.36 258.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "174.19 257.99 169.67 95.95 144.8 95.95 155.35 255.73 174.19 257.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0 159.66 89.22 18.78 123.03 142.76 158.72 49.78 139.94 46.96 191.59 0 193.47 71.38 176.57 52.59 118.34 184.08 85.47 43.2 0 159.66"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEconomiaAziendaleDeselected);
export default __webpack_public_path__ + "static/media/economiaAziendaleDeselected.e9859a1875ea3aa3836064ffd3b0d187.svg";
export { ForwardRef as ReactComponent };